import React from "react";

import { Instagram, Facebook, Link2 } from 'lucide-react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter, faYoutube, faTelegram } from "@fortawesome/free-brands-svg-icons";

const Socials = ({ artistSocials }) => {
    const socialIconMap = {
        "twitter": <FontAwesomeIcon icon={faXTwitter} />,
        "youtube": <FontAwesomeIcon icon={faYoutube} />,
        "telegram": <FontAwesomeIcon icon={faTelegram} />,
        "link": <Link2 />,
        "instagram": <Instagram />,
        "facebook": <Facebook />
    }
    const socialIcons = (socialName, path) => 
        <a href={path} target='_blank' key={socialName}>
            {socialIconMap[socialName]}
        </a>
  return (
    <>
        {Object.entries(artistSocials).map(([key, path]) => socialIcons(key, path))}
    </>);
}

export default Socials;